import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Zoom from "react-reveal/Zoom";
import { Fade } from "react-reveal";
import udemy from "../../images/udemy.jpg";
import engineersDay from "../../images/engineersDay.png";
import spiretech from "../../images/spiretech.png";

import hindustan from "../../images/hindustanCertificate.png";
import Particle from "../../Particle";
export default function CertificatePage() {
  return (
    <section className="home-section">
      <Container fluid id="home">
        <Particle />
        <Container className="home-content">
          <div
            className="d-flex justify-content-center"
            width="100%"
            // style={{ backgroundColor: "#fbd9ad" }}
          >
            <Zoom left cascade>
              <h1 className="project-heading">My <strong className="purple">Certificates</strong></h1>
            </Zoom>
          </div>
          <div>
            <div>
              <Container fluid className="certificate-section" id="about">
                <Container>
                  <Row>
                    <Col md={12} className="mt-5">
                      <Row className="g-5">
                        <Col lg={4} md={6}>
                          <Fade bottom duration={2000} distance="20px">
                            <div className="cert-card">
                              <div className="cert-header">
                                <a
                                  href="https://udemy-certificate.s3.amazonaws.com/image/UC-737e9eed-8950-4df7-9b6e-73817e4b6662.jpg?v=1666942555000"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <div className="content-overlay"></div>
                                  <img
                                    className="logo_img"
                                    src={udemy}
                                    alt="Udemy"
                                  />
                                  <div className="content-details fadeIn-top">
                                    <h3 className="content-title">View Certificate</h3>
                                  </div>
                                </a>
                              </div>
                              <div className="cert-body">
                                <h2 className="cert-body-title purple">
                                  The Complete 2022 Web Development Bootcamp
                                </h2>
                                <h3 className="cert-body-subtitle text-muted">
                                  Udemy
                                </h3>
                              </div>
                            </div>
                          </Fade>
                        </Col>
                        <Col lg={4} md={6}>
                          <Fade bottom duration={2000} distance="20px">
                            <div className="cert-card">
                              <div className="cert-header">
                                <a
                                  href={hindustan}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <div className="content-overlay"></div>
                                  <img
                                    className="logo_img"
                                    src={hindustan}
                                    alt="Hindustan Olympiad"
                                  />
                                  <div className="content-details fadeIn-top">
                                    <h3 className="content-title">View Certificate</h3>
                                  </div>
                                </a>
                              </div>
                              <div className="cert-body">
                                <h2 className="cert-body-title purple">
                                  Hindustan Olympiad - 93 Rank in district
                                </h2>
                                <h3 className="cert-body-subtitle text-muted">
                                  Hindustan Olympiad
                                </h3>
                              </div>
                            </div>
                          </Fade>
                        </Col>
                        <Col lg={4} md={6}>
                          <Fade bottom duration={2000} distance="20px">
                            <div className="cert-card">
                              <div className="cert-header">
                                <a
                                  href={spiretech}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <div className="content-overlay"></div>
                                  <img
                                    className="logo_img"
                                    src={spiretech}
                                    alt="Spiretech"
                                  />
                                  <div className="content-details fadeIn-top">
                                    <h3 className="content-title">View Certificate</h3>
                                  </div>
                                </a>
                              </div>
                              <div className="cert-body">
                                <h2 className="cert-body-title purple">
                                  Microsoft Azure Fundamentals Workshop
                                </h2>
                                <h3 className="cert-body-subtitle text-muted">
                                  Spiretech
                                </h3>
                              </div>
                            </div>
                          </Fade>
                        </Col>
                        <Col lg={4} md={6}>
                          <Fade bottom duration={2000} distance="20px">
                            <div className="cert-card">
                              <div className="cert-header">
                                <a
                                  href={engineersDay}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <div className="content-overlay"></div>
                                  <img
                                    className="logo_img"
                                    src={engineersDay}
                                    alt="Nexxplora"
                                  />
                                  <div className="content-details fadeIn-top">
                                    <h3 className="content-title">View Certificate</h3>
                                  </div>
                                </a>
                              </div>
                              <div className="cert-body">
                                <h2 className="cert-body-title purple">
                                  Engineers Day Participation
                                </h2>
                                <h3 className="cert-body-subtitle text-muted">
                                  Nexxplora-2020
                                </h3>
                              </div>
                            </div>
                          </Fade>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Container>
              </Container>
            </div>
          </div>
          <div className="blog--viewAll"></div>
        </Container>
      </Container>
    </section>
  );
}
